import Cookies from "js-cookie";
import { isObject, isEmptyObject } from "./helpers";

const set = <T>(name: string, values: T) => {
  Cookies.set(name, JSON.stringify(values));
};
const get = (name: string) => JSON.parse(Cookies.get(name) || "{}");

const exist = (name: string) => !!Cookies.get(name);

const withData = (name: string) => {
  if (!exist(name)) {
    return false;
  }
  const data = get(name);
  if (isObject(data)) {
    return !isEmptyObject(data);
  }
  return !!data;
};

const remove = (name: string) => {
  Cookies.remove(name);
};

const storage = {
  set,
  get,
  exist,
  withData,
  remove
};

export { storage };
